/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/mv_sum.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Converts a multivalued field into a single valued field containing the sum of all of the values.',
  examples: [
    'ROW a=[3, 5, 6]\n| EVAL sum_a = MV_SUM(a)',
  ],
  params: {
    number: 'Expression that can be null, a single value, or multiple values.',
  },
};

export default docs;
